import {getLFCData, setLFCData, setLFCDataProc} from '_logics/LFCUtil';
import {OptionsObject, SnackbarKey, SnackbarMessage} from 'notistack';

export type DeviceInfo = {
  device_name: string;
  display_name: string | null;
  robot_manufacturer: string | null;
  robot_model: string | null;
  installation_location: string | null;
  department: string | null;
  manager: string | null;
  memo: string | null;
  updated_at: string | null;
};

const SQL_ID_DEVICE_INFO_GET = 8013;
const SQL_ID_DEVICE_INFO_UPSERT = 8014;
const INVOKE_DELETE_DEVICE_HISTORY = 'DeleteDeviceHistory';

type SnackFn = (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey;

export const getDeviceInfoList = async (prm: {snack: SnackFn; t: any}): Promise<DeviceInfo[]> =>
  getLFCData({
    snack: prm.snack,
    sql_id: SQL_ID_DEVICE_INFO_GET,
    parameters: {},
    t: prm.t
  });

export const upsertDeviceInfo = async (prm: {
  snack: SnackFn;
  t: any;
  info: Partial<DeviceInfo> & {device_name: string};
}): Promise<void> => {
  await setLFCData({
    snack: prm.snack,
    sql_id: SQL_ID_DEVICE_INFO_UPSERT,
    parameters: {
      device_name: prm.info.device_name,
      display_name: prm.info.display_name ?? null,
      robot_manufacturer: prm.info.robot_manufacturer ?? null,
      robot_model: prm.info.robot_model ?? null,
      installation_location: prm.info.installation_location ?? null,
      department: prm.info.department ?? null,
      manager: prm.info.manager ?? null,
      memo: prm.info.memo ?? null
    },
    t: prm.t
  });
};

export const deleteDeviceHistory = async (prm: {
  snack: SnackFn;
  t: any;
  deviceName: string;
}): Promise<void> => {
  await setLFCDataProc({
    snack: prm.snack,
    invoke_name: INVOKE_DELETE_DEVICE_HISTORY,
    parameters: {device_name: prm.deviceName},
    t: prm.t
  });
};
